import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query';
import { refreshSession } from '@/lib/api';
import { useAuth } from '@/store/auth';
import { Toaster } from '@/components/ui';
import { router } from './router';

export function App() {
  useEffect(() => {
    // Platform console has its own session; skip tenant bootstrap there.
    if (window.location.pathname.startsWith('/platform')) {
      useAuth.getState().clear(null);
      return;
    }
    if (useAuth.getState().status === 'loading') void refreshSession();
  }, []);

  // Drop cached data whenever the signed-in identity changes (never leak data across sessions).
  useEffect(
    () =>
      useAuth.subscribe((s, prev) => {
        if (s.user?.id !== prev.user?.id) queryClient.clear();
      }),
    [],
  );

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  );
}
